import dayjs from 'dayjs';

import { logger } from 'Services/logger/logger';
import type { DateRangeFilterValue } from 'Types/account';
import { AccountDateRange } from 'Types/account';

enum DateFormat {
	default = 'YYYY-MM-DD',
	withTime = 'YYYY-MM-DDTHH:mm:ss',
}

const emptyDates = { from: undefined, to: undefined };

export const getAccountDateRange = (
	dateRangeType: AccountDateRange,
	date: Date | string = new Date(),
): DateRangeFilterValue => {
	const now = dayjs(date);
	const currentDate = now.format(DateFormat.default);
	const currentTime = now.format(DateFormat.withTime);
	const tomorrow = now.add(1, 'day').format(DateFormat.default);
	const yesterday = now.subtract(1, 'day').format(DateFormat.default);
	const last24Hours = now.subtract(1, 'day').format(DateFormat.withTime);
	const last48Hours = now.subtract(2, 'day').format(DateFormat.withTime);
	const last7Days = now.subtract(7, 'day').format(DateFormat.default);
	const last30Days = now.subtract(30, 'day').format(DateFormat.default);

	// @source https://github.com/motorway/motorway-dealership-platform/pull/947#issuecomment-708415770
	const ranges = {
		[AccountDateRange.ALL]: emptyDates,
		[AccountDateRange.TODAY]: { from: currentDate, to: tomorrow },
		[AccountDateRange.YESTERDAY]: { from: yesterday, to: currentDate },
		[AccountDateRange.LAST_24_HOURS]: { from: last24Hours, to: currentTime },
		[AccountDateRange.LAST_48_HOURS]: { from: last48Hours, to: currentTime },
		[AccountDateRange.LAST_7_DAYS]: { from: last7Days, to: tomorrow },
		[AccountDateRange.LAST_30_DAYS]: { from: last30Days, to: tomorrow },
	};

	if (!ranges[dateRangeType]) {
		const message = `Account date range type ${dateRangeType} is invalid`;
		logger.warn({ message, scope: 'getAccountDateRange' });

		return emptyDates;
	}

	const { from, to } = ranges[dateRangeType];

	return { from, to };
};
